import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query SkillsDirectories {
  requestTypeDirectories {
    id
    name
    description
    team {
      id
      name
    }
    requestTypes {
      priority
      requestType {
        id
        name
        active
        description
      }
    }
    priority
  }
}`;

function getSkillsDirectories() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.requestTypeDirectories);
}

export default getSkillsDirectories;
